/**
 * Session Observation Form review. The evidence-first sheet lives in
 * `./sofReview/`; this module keeps the import path the workspace screen uses.
 */
export { SofReviewSheet as SofReviewModal, type SofReviewSheetProps as SofReviewModalProps } from './sofReview/SofReviewSheet';
